module.exports = __webpack_public_path__ + "media/sv_se_s1_Astrid.0e99b206.oga";